// extracted by mini-css-extract-plugin
export default {"ContactPage":"ContactPage_ContactPage__y2vvI","Email":"ContactPage_Email__ip3vR","shadow-pulse":"ContactPage_shadow-pulse__HICKg","breathe":"ContactPage_breathe__Ml-ja"};